import React, { ReactNode } from 'react';
import { Footer } from './Footer';
import { CallToAction } from '../ui/CallToAction';

interface LayoutProps {
	children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
	return (
		<div className='flex flex-col w-full overflow-hidden'>
			<main className='w-full'>{children}</main>
			<CallToAction />
			<Footer />
		</div>
	);
};

export default Layout;
